import {
  useEffect,
  useState
} from "react";

import {
  Link,
  useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Businesses() {

  const navigate =
    useNavigate();

  const [businesses,
    setBusinesses] =
    useState([]);

  const [page,
    setPage] =
    useState(1);

  const [pages,
    setPages] =
    useState(1);

  const [search,
    setSearch] =
    useState("");

  useEffect(() => {

    loadBusinesses();

  }, [page, search]);

  const loadBusinesses =
    async () => {

      try {

        const res =
          await API.get(
            `/businesses?page=${page}&search=${search}`
          );

        setBusinesses(
          res.data.businesses || []
        );

        setPages(
          res.data.pages || 1
        );

      } catch (err) {

        console.log(err);

      }

    };

  const deleteBusiness =
    async (id) => {

      if (
        !window.confirm(
          "Delete Business?"
        )
      ) return;

      try {

        await API.delete(
          `/businesses/${id}`
        );

        loadBusinesses();

      } catch (err) {

        console.log(err);

      }

    };

  return (

    <div>

      {/* Header */}

      <div
        className="
        flex
        flex-col
        md:flex-row
        md:justify-between
        md:items-center
        gap-4
        mb-6
        "
      >

        <h1
          className="
          text-4xl
          font-bold
          "
        >
          Businesses
        </h1>

        {hasPermission("business.add") && (
          <Link
            to="/admin/businesses/add"
            className="
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
          text-center
          "
          >
            + Add Business
          </Link>
        )}


      </div>

      {/* Search */}

      <input
        value={search}
        onChange={(e) =>
          setSearch(
            e.target.value
          )
        }
        placeholder="Search Business..."
        className="
        w-full
        md:w-96
        p-3
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        mb-6
        outline-none
        "
      />

      {/* Mobile */}

      <div
        className="
        md:hidden
        space-y-4
        "
      >

        {businesses.map(
          (item) => (
            <div
              key={item.id}
              className="
              bg-[#111]
              rounded-2xl
              p-5
              border
              border-yellow-500/10
              "
            >

              <div
                className="
                flex
                items-center
                gap-4
                "
              >

                <img
                  src={
                    item.logo
                      ? `${process.env.REACT_APP_API_URL}/uploads/${item.logo}`
                      : "https://ui-avatars.com/api/?name=Business"
                  }
                  alt=""
                  className="
                  w-16
                  h-16
                  rounded-xl
                  object-cover
                  "
                />

                <div>

                  <h2
                    className="
                    font-bold
                    text-lg
                    "
                  >
                    {item.business_name}
                  </h2>

                  <p
                    className="
                    text-sm
                    text-gray-400
                    "
                  >
                    {item.owner_name}
                  </p>

                </div>

              </div>

              <div className="mt-4">

                <p>
                  📞 {item.phone}
                </p>

                <p>
                  ✉ {item.email}
                </p>

                <p
                  className="
                  mt-2
                  "
                >

                  <span
                    className={
                      Number(item.status) === 1
                        ? "text-green-500"
                        : "text-red-500"
                    }
                  >

                    {
                      Number(item.status) === 1
                        ? "Active"
                        : "Inactive"
                    }

                  </span>

                </p>

              </div>

              <div
                className="
                flex
                gap-2
                mt-5
                "
              >

                <button
                  onClick={() =>
                    navigate(
                      `/admin/businesses/view/${item.id}`
                    )
                  }
                  className="
                  flex-1
                  bg-green-500
                  py-2
                  rounded-lg
                  "
                >
                  View
                </button>

                <button
                  onClick={() =>
                    navigate(
                      `/admin/businesses/edit/${item.id}`
                    )
                  }
                  className="
                  flex-1
                  bg-blue-500
                  py-2
                  rounded-lg
                  "
                >
                  Edit
                </button>

                <button
                  onClick={() =>
                    deleteBusiness(
                      item.id
                    )
                  }
                  className="
                  flex-1
                  bg-red-500
                  py-2
                  rounded-lg
                  "
                >
                  Delete
                </button>

              </div>

            </div>
          )
        )}

      </div>

      {/* Desktop */}

      <div
        className="
        hidden
        md:block
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
      >

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead>

              <tr
                className="
                border-b
                border-yellow-500/20
                "
              >

                <th className="p-4 text-left">
                  Logo
                </th>

                <th className="p-4 text-left">
                  Business
                </th>

                <th className="p-4 text-left">
                  Owner
                </th>

                <th className="p-4 text-left">
                  Phone
                </th>

                <th className="p-4 text-left">
                  Email
                </th>

                <th className="p-4 text-left">
                  Status
                </th>

                <th className="p-4 text-left">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {businesses.map(
                (item) => (
                  <tr
                    key={item.id}
                    className="
                    border-b
                    border-yellow-500/10
                    "
                  >

                    <td className="p-4">

                      <img
                        src={
                          item.logo
                            ? `${process.env.REACT_APP_API_URL}/uploads/${item.logo}`
                            : "https://ui-avatars.com/api/?name=Business"
                        }
                        alt=""
                        className="
                        w-14
                        h-14
                        rounded-lg
                        object-cover
                        "
                      />

                    </td>

                    <td className="p-4">
                      {item.business_name}
                    </td>

                    <td className="p-4">
                      {item.owner_name}
                    </td>

                    <td className="p-4">
                      {item.phone}
                    </td>

                    <td className="p-4">
                      {item.email}
                    </td>

                    <td className="p-4">

                      <span
                        className={
                          Number(item.status) === 1
                            ? "text-green-500"
                            : "text-red-500"
                        }
                      >

                        {
                          Number(item.status) === 1
                            ? "Active"
                            : "Inactive"
                        }

                      </span>

                    </td>

                    <td className="p-4">

                      <div
                        className="
                        flex
                        gap-2
                        "
                      >

                        {hasPermission("business.view") && (
                          <button
                            onClick={() =>
                              navigate(
                                `/admin/businesses/view/${item.id}`
                              )
                            }
                            className="
                          bg-green-500
                          px-4
                          py-2
                          rounded-lg
                          "
                          >
                            View
                          </button>
                        )}

                        {hasPermission("business.edit") && (
                          <button
                            onClick={() =>
                              navigate(
                                `/admin/businesses/edit/${item.id}`
                              )
                            }
                            className="
                          bg-blue-500
                          px-4
                          py-2
                          rounded-lg
                          "
                          >
                            Edit
                          </button>
                        )}

                        {hasPermission("business.delete") && (
                          <button
                            onClick={() =>
                              deleteBusiness(
                                item.id
                              )
                            }
                            className="
                          bg-red-500
                          px-4
                          py-2
                          rounded-lg
                          "
                          >
                            Delete
                          </button>
                        )}

                      </div>

                    </td>

                  </tr>
                )
              )}

            </tbody>

          </table>

        </div>

      </div>

      {/* Pagination */}

      <div
        className="
        flex
        gap-2
        mt-6
        flex-wrap
        "
      >

        <button
          disabled={page === 1}
          onClick={() =>
            setPage(page - 1)
          }
          className="
          px-4
          py-2
          bg-[#111]
          rounded-lg
          "
        >
          Back
        </button>

        {[...Array(pages)].map(
          (_, i) => (
            <button
              key={i}
              onClick={() =>
                setPage(i + 1)
              }
              className={`
              px-4
              py-2
              rounded-lg
              ${page === i + 1
                  ? "bg-yellow-500 text-black"
                  : "bg-[#111]"
                }
              `}
            >
              {i + 1}
            </button>
          )
        )}

        <button
          disabled={page === pages}
          onClick={() =>
            setPage(page + 1)
          }
          className="
          px-4
          py-2
          bg-[#111]
          rounded-lg
          "
        >
          Next
        </button>

      </div>

    </div>

  );

}

export default Businesses;